export var PhotoCaptureDownloadArtifactsLabelNames;
(function (PhotoCaptureDownloadArtifactsLabelNames) {
    PhotoCaptureDownloadArtifactsLabelNames["FRONT_LEFT"] = "Front Left";
    PhotoCaptureDownloadArtifactsLabelNames["FRONT_RIGHT"] = "Front Right";
    PhotoCaptureDownloadArtifactsLabelNames["MILEAGE"] = "Mileage";
    PhotoCaptureDownloadArtifactsLabelNames["ODOMETER"] = "Odometer";
    PhotoCaptureDownloadArtifactsLabelNames["PLATE"] = "Plate";
    PhotoCaptureDownloadArtifactsLabelNames["REAR_LEFT"] = "Rear Left";
    PhotoCaptureDownloadArtifactsLabelNames["REAR_RIGHT"] = "Rear Right";
    PhotoCaptureDownloadArtifactsLabelNames["VIN"] = "Vin Windshield";
    PhotoCaptureDownloadArtifactsLabelNames["VIN_STICKER"] = "Vin Sticker";
})(PhotoCaptureDownloadArtifactsLabelNames || (PhotoCaptureDownloadArtifactsLabelNames = {}));
//# sourceMappingURL=PhotoCaptureDownloadArtifactsLabelNames.js.map